import React from 'react';
import { Route } from 'react-router-dom';
import ManageExams from '@/pages/examination/ManageExams';
import ExamAttendance from '@/pages/examination/ExamAttendance';
import MarksEntry from '@/pages/examination/MarksEntry';
import MarksTabulation from '@/pages/examination/MarksTabulation';
import Results from '@/pages/examination/Results';
import ExamResult from '@/pages/examination/ExamResult';
import GradingSystem from '@/pages/examination/GradingSystem';
import ExamType from '@/pages/examination/ExamType';
import AdmitCards from '@/pages/examination/AdmitCards';
import MarkDistribution from '@/pages/examination/MarkDistribution';
import AdmitSetting from '@/pages/examination/AdmitSetting';
import MarksheetSetting from '@/pages/examination/MarksheetSetting';
import ExamFeePayment from '@/pages/examination/ExamFeePayment';
import ExamAttendanceReport from '@/pages/examination/ExamAttendanceReport';
import ExamFeeReport from '@/pages/examination/ExamFeeReport';
import PromoteStudent from '@/pages/examination/PromoteStudent';
import PromotionReport from '@/pages/examination/PromotionReport';
import FailedStudents from '@/pages/examination/FailedStudents';

export const examinationRoutes = (
  <React.Fragment>
    <Route path="examination/manage-exams" element={<ManageExams />} />
    <Route path="examination/exam-attendance" element={<ExamAttendance />} />
    <Route path="examination/marks-entry" element={<MarksEntry />} />
    <Route path="examination/marks-tabulation" element={<MarksTabulation />} />
    <Route path="examination/results" element={<Results />} />
    <Route path="examination/exam-result" element={<ExamResult />} />
    <Route path="examination/grading-system" element={<GradingSystem />} />
    <Route path="examination/exam-type" element={<ExamType />} />
    <Route path="examination/admit-cards" element={<AdmitCards />} />
    <Route path="examination/mark-distribution" element={<MarkDistribution />} />
    <Route path="examination/admit-setting" element={<AdmitSetting />} />
    <Route path="examination/marksheet-setting" element={<MarksheetSetting />} />
    <Route path="examination/exam-fee-payment" element={<ExamFeePayment />} />
    <Route path="examination/exam-attendance-report" element={<ExamAttendanceReport />} />
    <Route path="examination/exam-fee-report" element={<ExamFeeReport />} />
    <Route path="examination/promote-student" element={<PromoteStudent />} />
    <Route path="examination/promotion-report" element={<PromotionReport />} />
    <Route path="examination/failed-students" element={<FailedStudents />} />
  </React.Fragment>
);
